export default "__VITE_ASSET__BNJYq5Mg__"